import { render } from "./KatisashiList.vue?vue&type=template&id=377bd6d1&scoped=true"
import script from "./KatisashiList.vue?vue&type=script&lang=js"
export * from "./KatisashiList.vue?vue&type=script&lang=js"

import "./KatisashiList.vue?vue&type=style&index=0&id=377bd6d1&scoped=true&lang=css"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377bd6d1"]])

export default __exports__